/* DBS FX
 * - waterfall intro (first visit of the session)
 * - random sound clip on first load
 * - chaos text: random letter case + random fonts on some words
 * - floaty buttons / jittery payment icons (random timing)
 */
(function () {
  'use strict';

  var D = window.DBS || {};
  var root = document.documentElement;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  /* ------------------------------------------------------------------
   * 1. WATERFALL INTRO
   * Black canvas over the page. A pixelated front moves down from the
   * top; behind it the page is revealed. The trailing edge is made of
   * square pixels (ragged, with drips) until the bottom is reached.
   * ------------------------------------------------------------------ */
  function waterfall() {
    if (!root.classList.contains('dbs-wf-pending')) return;
    if (reduce || !document.body) {
      root.classList.remove('dbs-wf-pending');
      sset('dbsWaterfall', '1');
      try { sessionStorage.removeItem('dbsWfForce'); } catch (e) {}
      playSting();
      return;
    }

    var CELL = window.innerWidth < 750 ? 10 : 14;           // pixel size
    var BAND = Math.round(Math.min(window.innerHeight * 0.35, 280)); // depth of the ragged edge
    var DURATION = 1500;                                     // ms, top to bottom

    var cols = Math.ceil(window.innerWidth / CELL);
    var rows = Math.ceil(window.innerHeight / CELL);

    var cv = document.createElement('canvas');
    cv.width = cols; cv.height = rows;
    cv.className = 'dbs-wf-canvas';
    cv.style.width = (cols * CELL) + 'px';
    cv.style.height = (rows * CELL) + 'px';
    var ctx = cv.getContext('2d');
    var img = ctx.createImageData(cols, rows);
    var px = new Uint32Array(img.data.buffer);
    var BLACK = 0xFF000000; // opaque black (little-endian RGBA)
    var i, x, y;
    for (i = 0; i < px.length; i++) px[i] = BLACK;
    ctx.putImageData(img, 0, 0);
    document.body.appendChild(cv);
    root.classList.remove('dbs-wf-pending'); // canvas now holds the black
    sset('dbsWaterfall', '1');               // once per visit...
    try { sessionStorage.removeItem('dbsWfForce'); } catch (e) {} // ...plus after Home / Cart clicks
    playSting();

    // per-column streaks (drips): smoothed noise plus a few long drips
    var col = new Float32Array(cols);
    for (x = 0; x < cols; x++) col[x] = Math.random();
    for (var pass = 0; pass < 2; pass++) {
      for (x = 1; x < cols - 1; x++) col[x] = (col[x - 1] + col[x] * 2 + col[x + 1]) / 4;
    }
    var mn = 1, mx = 0;
    for (x = 0; x < cols; x++) { if (col[x] < mn) mn = col[x]; if (col[x] > mx) mx = col[x]; }
    for (x = 0; x < cols; x++) col[x] = (col[x] - mn) / ((mx - mn) || 1);
    for (var k = 0; k < cols / 9; k++) col[(Math.random() * cols) | 0] = 1;

    // when the front passes a cell's threshold, that cell is revealed
    var thr = new Float32Array(cols * rows);
    for (y = 0; y < rows; y++) {
      for (x = 0; x < cols; x++) {
        thr[y * cols + x] = y * CELL + col[x] * BAND * 1.1 + Math.random() * BAND * 0.28;
      }
    }
    var maxT = rows * CELL + BAND * 1.4;

    // pixel DBS logo: blinks in on the black, holds, then the waterfall washes it away
    var LOGOS = {
      56: ["......................y....................", ".....................yy....................", ".....................yy....................", ".....................yy....................", ".....................yy....................", ".....................yy....................", ".....................yy....................", ".....................yy....................", ".....................yy....................", "....................yyy....................", "....................yyy..............yyy...", "....................yyy............yyyyy...", "...y................yyy............yyyy....", "...yyyy.............yyy............yyy.....", "...yyyyy............yyy..........yyy.......", "....yyy.............yyy..........yy........", ".....yyy............yyyyyy.....yyy.........", ".......yyy.......yyyyy..yyyyyyyyy..........", ".........yy....yyyy..........yyy...........", "..........yy.yyy..............yy...........", "...........yyy.................yy..........", "..........yyy.............yy...yy..........", ".........yyy..yy........yyyyy..yy..........", "........yy....yyyyyy...yyyyy...yy..........", ".......yy.....yyyyyy...yyy.....yy..........", ".......y.........yyy...yyy...y.y...........", "......yy.........yyy...yy...y.yy...........", "......yy.........yy....yy.yyy.y............", "......yy.........yy....yy..yy.y............", "......yy....yy...yy....yy..yyyy............", "......yyyyyyy..............yyy.............", "......yyyyyyyy...........yyyyy.............", "......yy....yy...........yy.yy.............", ".......y.....yyy........yy..y..............", ".......yy.....yyy.....yyyy.yy..............", "........yy.....yyyyyyyy...yyy..............", "........yy.........yyy...yy.yyy............", ".........yy..........yyy.y....yy...........", "........yyy.........yy.yyy.....yy..........", ".......yyy..........yy.yyy......yy.........", "......yy.y...yy.....yyyyyy.......yy........", "....yyy..y.yyyy..y..yyyyy.........yyy......", "..yyyy...y.yy.yyyyyyyyy.y.yy.......yyyyy...", ".yyyy....yyy..y.yyyyyyy.y.yy........yyyyyyy", "yyyyy....yy..yy.y.yyyy.yy.yy........yyyyyy.", "..yyy........yy.y..yyy.yy.yy........yyy....", "..yyy........y.yy..yyy.y..yy.........yy....", "...yy........y.y...yy.yy.............y.....", "............yyyy...yy.yy...................", "............yyyy.yyyyyy....................", "............yyy..yyyyyyy...................", "............yyy...yyy......................", "............yy.....yy......................", "...................yy......................", "...................yy......................", "...................y......................."],
      40: ["...............y..............", "...............y..............", "..............yy..............", "..............yy..............", "..............yy..............", "..............yy..............", "..............yy..............", "..............yy.........yyy..", "..y...........yy........yyyy..", "..yyy.........yy........yyy...", "..yyy.........yy.......yy.....", "...yyy........yyy.....yy......", ".....yy.....yyyyyyyyyyy.......", "......yy..yyy.......yy........", ".......yyy...........yy.......", ".......yy.........yy..y.......", "......yy.yyyy...yyyy..y.......", ".....y....yyyy..yyy...y.......", "....yy......yy..yy..yyy.......", "....yy......yy..yy.y.y........", "....yy......y...y..yyy........", "....yyyyyy..y......yyy........", "....yyyyyy.......yyyy.........", "....yy..yyy......y.yy.........", ".....y...yyy...yyy.y..........", ".....yy...yyyyyy..yyy.........", "......yy.......yyyy.yy........", ".....yyy......yyyy...yy.......", "....yyy..y....yyyy....yy......", "...yy.y.yyy.y.yyyy.....yyy....", ".yyy..yyy.yyyyyyyyyy.....yyyy.", "yyyy..yy.yyyyyyyyyyy.....yyyyy", ".yyy.....y.y.yyyy.yy.....yyy..", "..yy.....yyy.yy.y.yy......y...", ".........yy..yyyy.............", "........yyy.yyyy..............", "........yyy..yyy..............", "........yy...yy...............", ".............yy...............", ".............y................"],
      28: ["..........y..........", "..........y..........", "..........y..........", "..........y..........", "..........y..........", "..........y......yyy.", ".yy.......y......yy..", "..yy......y.....yy...", "..yyy...yyyyyy.yy....", "....yyyyy.....yy.....", ".....yy........y.....", "....yy.yyy.yyy.y.....", "...y...yyy.yy..y.....", "...y....yy.y.yyy.....", "...y..y.y..y.yy......", "...yyyy.....yyy......", "...y..yy....yyy......", "...yy..yyyyyyy.......", "....y....yyyy.yy.....", "...yy.....yyy..yy....", "..yyy.yyyyyyy...yy...", "yyy.yy.yyyyyyy...yyyy", "yyy.y.yyyyyy.y...yyy.", ".yy...yy.yyy.y....y..", "......yyyyyy.........", "......yyyyyy.........", "......y..y...........", ".........y..........."]
    };
    var LOGO_IN = 220, HOLD = 330;
    var LOGO_COLOR = 0xFF00E6FF;   // #ffe600 (little-endian RGBA)
    var WHITE = 0xFFFFFFFF;
    var logo = null;
    [56, 40, 28].some(function (h) {
      var L = LOGOS[h];
      if (L.length <= rows * 0.62 && L[0].length <= cols * 0.85) { logo = L; return true; }
      return false;
    });
    var logoCells = [];
    if (logo) {
      var lh = logo.length, lw = logo[0].length;
      var ox = ((cols - lw) / 2) | 0, oy = ((rows - lh) / 2) | 0;
      for (y = 0; y < lh; y++) {
        for (x = 0; x < lw; x++) {
          if (logo[y].charAt(x) === 'y') logoCells.push({ i: (oy + y) * cols + ox + x, at: Math.random() * LOGO_IN });
        }
      }
    }
    var START = logoCells.length ? LOGO_IN + HOLD : 0;
    var t0 = performance.now();

    function frame(now) {
      var t = now - t0, n;
      if (t < START) {
        // logo phase: cells pop in, with a little white glitch flicker
        for (n = 0; n < logoCells.length; n++) {
          var c = logoCells[n];
          if (c.at <= t) px[c.i] = Math.random() < 0.04 ? WHITE : LOGO_COLOR;
        }
        ctx.putImageData(img, 0, 0);
        requestAnimationFrame(frame);
        return;
      }
      if (logoCells.length && !frame.settled) {
        frame.settled = true;
        for (n = 0; n < logoCells.length; n++) px[logoCells[n].i] = LOGO_COLOR;
      }
      var p = Math.min(1, (t - START) / DURATION);
      var e = -(Math.cos(Math.PI * p) - 1) / 2; // easeInOutSine
      var front = e * maxT;
      for (n = 0; n < px.length; n++) {
        if (px[n] !== 0 && front >= thr[n]) px[n] = 0;
      }
      ctx.putImageData(img, 0, 0);
      if (p < 1) requestAnimationFrame(frame);
      else if (cv.parentNode) cv.parentNode.removeChild(cv);
    }
    requestAnimationFrame(frame);
  }

  /* ------------------------------------------------------------------
   * 2. STING: a random clip that plays together with the waterfall
   * (first page of a visit, and after Home / Cart clicks). Skipped while
   * the jukebox is playing. Browsers may block it if the visitor hasn't
   * clicked anything on the site yet; in that case it simply stays quiet.
   * ------------------------------------------------------------------ */
  function playSting() {
    if (designMode) return;
    try { var j = JSON.parse(sget('dbsj') || '{}'); if (j.open && j.playing) return; } catch (e) {} // jukebox open + playing
    var list = D.clips || [];
    if (!list.length) return;
    var last = sget('dbsClipLast'), pick;
    do { pick = list[Math.floor(Math.random() * list.length)]; } while (list.length > 1 && pick === last);
    sset('dbsClipLast', pick);
    var a = new Audio(pick);
    a.volume = 0.85;
    var pr = a.play();
    if (pr && pr.catch) pr.catch(function () {});
  }

  /* ------------------------------------------------------------------
   * 3. CHAOS TEXT
   * Every word is wrapped in a span once. A timer re-randomizes the
   * letter case of a few visible words, and gives a few of them a
   * different font. Original text is kept in data-o.
   * ------------------------------------------------------------------ */
  var words = [];
  var visible = new Set();
  var fontWords = [];
  var FONT_COUNT = 9;
  var io = null;

  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, SELECT: 1, OPTION: 1, svg: 1, SVG: 1,
               IFRAME: 1, CODE: 1, PRE: 1, AUDIO: 1, VIDEO: 1, CANVAS: 1, INPUT: 1 };

  function eligible(node) {
    var p = node.parentNode;
    while (p && p !== document.body) {
      if (p.nodeType === 1) {
        if (SKIP[p.nodeName] || p.hasAttribute('data-no-chaos') || p.isContentEditable) return false;
        if (p.classList && (p.classList.contains('dbs-w') || p.classList.contains('product__description'))) return false;
      }
      p = p.parentNode;
    }
    return !!p;
  }

  function wrapTextNode(n) {
    if (!n.parentNode || !/[A-Za-z]/.test(n.nodeValue)) return;
    var parts = n.nodeValue.split(/(\s+)/);
    var frag = document.createDocumentFragment();
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      if (!part) continue;
      if (/^\s+$/.test(part) || !/[A-Za-z]/.test(part)) {
        frag.appendChild(document.createTextNode(part));
      } else {
        var s = document.createElement('span');
        s.className = 'dbs-w';
        s.setAttribute('data-o', part);
        s.textContent = part;
        words.push(s);
        if (io) io.observe(s);
        frag.appendChild(s);
      }
    }
    n.parentNode.replaceChild(frag, n);
  }

  function wrapTree(rootNode) {
    var walker = document.createTreeWalker(rootNode, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || !/[A-Za-z]/.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        return eligible(n) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var list = [];
    while (walker.nextNode()) list.push(walker.currentNode);
    for (var i = 0; i < list.length; i++) wrapTextNode(list[i]);
  }

  function randCase(str) {
    var out = '';
    for (var i = 0; i < str.length; i++) {
      var c = str.charAt(i);
      out += Math.random() < 0.5 ? c.toUpperCase() : c.toLowerCase();
    }
    return out;
  }

  function tickCase() {
    var vis = Array.from(visible);
    if (!vis.length) return;
    var n = Math.min(vis.length, 28);
    for (var i = 0; i < n; i++) {
      var s = vis[(Math.random() * vis.length) | 0];
      if (!s.isConnected || !s.firstChild) continue;
      s.firstChild.nodeValue = randCase(s.getAttribute('data-o'));
    }
  }

  function tickFont() {
    var vis = Array.from(visible);
    if (!vis.length) return;
    // retire a few old font words
    var retire = Math.max(1, Math.round(fontWords.length * 0.35));
    for (var r = 0; r < retire && fontWords.length; r++) {
      var old = fontWords.shift();
      old.className = 'dbs-w';
    }
    // give new words a font (about 5% of what is on screen, max 24 at once)
    var target = Math.min(24, Math.max(2, Math.round(vis.length * 0.05)));
    while (fontWords.length < target) {
      var s = vis[(Math.random() * vis.length) | 0];
      if (!s.isConnected) break;
      s.className = 'dbs-w dbs-f' + ((Math.random() * FONT_COUNT) | 0);
      fontWords.push(s);
    }
  }

  function initChaos() {
    if (designMode || reduce || !document.body) return;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) visible.add(entries[i].target);
          else visible.delete(entries[i].target);
        }
      });
    }
    wrapTree(document.body);
    // start with a first scramble so it looks alive right away
    if (!io) words.forEach(function (w) { visible.add(w); });
    setInterval(tickCase, 450);
    setInterval(tickFont, 1400);
    setInterval(function () {
      words = words.filter(function (w) { return w.isConnected; });
    }, 30000);
  }

  /* ------------------------------------------------------------------
   * 4. FLOATY BUTTONS + JITTERY PAYMENT ICONS
   * CSS does the motion; JS just gives each element its own timing so
   * nothing moves in sync.
   * ------------------------------------------------------------------ */
  function randomizeMotion(scope) {
    var s = scope && scope.querySelectorAll ? scope : document;
    var btns = s.querySelectorAll('.button, .shopify-payment-button__button, .dbsx-float');
    var i, el;
    for (i = 0; i < btns.length; i++) {
      el = btns[i];
      if (el.__dbsf) continue;
      el.__dbsf = 1;
      el.style.setProperty('--dbs-fd', (3 + Math.random() * 2.6).toFixed(2) + 's');
      el.style.setProperty('--dbs-fdelay', (-Math.random() * 6).toFixed(2) + 's');
    }
    var pay = s.querySelectorAll('.list-payment__item');
    for (i = 0; i < pay.length; i++) {
      el = pay[i];
      if (el.__dbsf) continue;
      el.__dbsf = 1;
      el.style.setProperty('--dbs-jd', (0.45 + Math.random() * 0.5).toFixed(2) + 's');
      el.style.setProperty('--dbs-jdelay', (-Math.random()).toFixed(2) + 's');
    }
  }

  /* ------------------------------------------------------------------
   * Keep up with content added later (cart updates, quick view, etc.)
   * ------------------------------------------------------------------ */
  function watch() {
    if (!('MutationObserver' in window)) return;
    var queue = [];
    var timer = null;
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && n.classList && n.classList.contains('dbs-w')) continue;
          if (n.nodeType === 3 && !/[A-Za-z]/.test(n.nodeValue)) continue;
          queue.push(n);
        }
      }
      if (!queue.length || timer) return;
      timer = setTimeout(function () {
        var batch = queue; queue = []; timer = null;
        for (var k = 0; k < batch.length; k++) {
          var node = batch[k];
          if (!node.isConnected) continue;
          if (node.nodeType === 3) {
            if (!designMode && !reduce && eligible(node)) wrapTextNode(node);
          } else if (node.nodeType === 1) {
            if (!designMode && !reduce) wrapTree(node);
            randomizeMotion(node);
          }
        }
      }, 60);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* Clicking Home or Cart replays the waterfall on the page it opens */
  function armWaterfallLinks() {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('data-dbs-jukebox') || (a.getAttribute('href') || '').charAt(0) === '#') return;
      var u;
      try { u = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
      if (u.origin !== location.origin) return;
      var path = u.pathname.replace(/\/+$/, '') || '/';
      if (path === '/' || path === '/cart') sset('dbsWfForce', String(Date.now()));
    }); // bubble phase: if the theme opens a cart drawer instead (preventDefault), nothing is armed
  }

  function init() {
    armWaterfallLinks();
    waterfall();
    randomizeMotion(document);
    initChaos();
    watch();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
